export enum SearchDatabaseOptions {
  USE_COMPANY_DATABASE_ONLY = 'USE_COMPANY_DATABASE_ONLY',
  USE_COMPANY_AND_SCALEUP_DATABASE = 'USE_COMPANY_AND_SCALEUP_DATABASE',
}
